import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../environments/environment.service';
import { CallService } from '../call-service/browser/call.service';
import { getCreateClickLogUrl, getCreatePageViewUrl } from '../router/routes-provider';
import { ClickDetail, ClickDetailID, ClickLog, ClickLogID } from './click.models';

@Injectable({
	providedIn: 'root'
})
export class ClickService {
	CreatePageView(clickDetail: ClickDetail): Observable<ClickDetailID> {
		const url = getCreatePageViewUrl();

		const result = this.callService.CallApi<ClickDetailID>(
			'POST',
			url,
			JSON.stringify(clickDetail)
		);
		return result;
	}

	CreateClickLog(clickLog: ClickLog): Observable<ClickLogID> {
		const url = getCreateClickLogUrl();

		const result = this.callService.CallApi<ClickLogID>(
			'POST',
			url,
			JSON.stringify(clickLog)
		);
		return result;
	}

	CreateClickLogOnUnload(clickLog: ClickLog): void {
		// Fired on pagehide. Use sendBeacon (not fetch) so the browser owns
		// delivery after the document is torn down — the most reliable unload
		// transport, especially on mobile. It can't set an Authorization header,
		// so it targets the session-authenticated ROOT /createclicklog (the
		// session cookie rides along automatically), NOT /api/createclicklog —
		// which also stops losing the event when the cached access token has
		// expired on unload. text/plain dodges a CORS preflight; the endpoint
		// reads the JSON body regardless of content-type.
		try {
			const url = this.environmentService.backendDomain + getCreateClickLogUrl();
			const blob = new Blob([JSON.stringify(clickLog)], { type: 'text/plain' });
			navigator.sendBeacon(url, blob);
		} catch {
			// Best effort — silently ignore
		}
	}

	constructor(
		private callService: CallService,
		private environmentService: EnvironmentService
	) {}
}
